module.exports = __webpack_public_path__ + "static/media/petScreen.5c3f5b3e.jpg";